import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './locales/en';
import ko from './locales/ko';
import ja from './locales/ja';
import zhHans from './locales/zh-Hans';
import zhHant from './locales/zh-Hant';
import zhHantHK from './locales/zh-Hant-HK';
import th from './locales/th';

const savedLang = localStorage.getItem('lang'); // ❗ 언어 선택 여부 확인

i18n.use(initReactI18next).init({
  resources: {
    ko: {translation: ko},
    en: {translation: en},
    ja: {translation: ja},
    'zh-Hans': {translation: zhHans},
    'zh-Hant': {translation: zhHant},
    'zh-Hant-HK': {translation: zhHantHK},
    th: {translation: th},
  },
  lng: savedLang ?? undefined, // 👉 저장된 언어가 없으면 언어 선택 화면이 뜨도록 undefined
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
